import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Address } from 'src/app/shared/Interfaces/customer';
import { environment } from 'src/environments/environment';

export interface Coordinates {
  accuracy: number;
  altitude: number | null;
  altitudeAccuracy: number | null;
  heading: number | null;
  latitude: number;
  longitude: number;
  speed: number | null;
}

export interface firstResult{
  response: results
}
export interface results{
  results: addressGoogle[]
}
export interface addressGoogle{
  address_components: addressForm[]
}
export interface addressForm{
  long_name: string,
  short_name: string
}

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

  addressInitial!: Address;
  googleKey: string = environment.googleKey

  id_AddressSubject: BehaviorSubject<Address | undefined> = new BehaviorSubject<Address | undefined>(undefined);
  id_Address$: Observable<Address | undefined> = this.id_AddressSubject.asObservable();


  constructor(private httpClient: HttpClient) { }

  //GET - Resgata a permissão de localização do navegador.
  getLocation(): Promise<Coordinates> {
    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position.coords),
          (error) => reject(error),
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 20000
          }
        );
      } else {
        reject('Geolocation is not supported by your browser');
      }
    });
  }

  //GET - Resgata a localização real do google passando Latitude / Longitude.
  getLocalizationReal(lat: number, long: number): Observable<any>{

    let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&location_type=ROOFTOP&result_type=street_address&key=${this.googleKey}`
    return this.httpClient.get<any>(url);
  }

  //GET - Resgata o CEP utilizando a API VIACEP
  getCep(cep: number):Observable<any>{
    let url = `https://viacep.com.br/ws/${cep}/json/`
    return this.httpClient.get<any>(url)
  }
}
